module.exports = __webpack_public_path__ + "assets/img/life-3.6af35a9c.jpg";